export const WHITE_COLOR = "#fff";
export const BLACK_COLOR = "#000";
export const RED_COLOR = "#DB1931";
export const GREY_COLOR = "#282829";
export const SOFT_GREY_COLOR = "#373739";
export const YELLOW_COLOR = "#F7B450";
